import Vue from 'vue'
import { minimalSinister } from '@/transformers/sinister'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * @param slug sinister's slug
 * @param id Casualy's id
 *
 * Fetch sinisters or sinister
 * @return {Array}
 * @return {Object}
 */

export default (slug = '', id) => {
  return Vue.$http.get(`sinister/no-permission/${slug}/${id}/`)
    .then(({ data }) => minimalSinister.fetch(data))
}
